
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { packageList, track } from '@/services/http';

interface TrackingEvent {
  title: string;
  time: string;
  description: string;
}

interface LogisticsPackage {
  id: string;
  label: string;
  company: string;
  number: string;
  events: TrackingEvent[];
}

@Component({
  components: { Header, Footer }
})
export default class Logistics extends Vue {
  packages: LogisticsPackage[] = [];

  activePackageIndex: number = 0;

  async created() {
    const orderNo = String(this.$route.query.id || this.$route.query.orderNo || '');
    if (!orderNo) return;
    const res: any = await packageList({ orderNo });
    if (res.data.code === 100 && Array.isArray(res.data.data)) {
      this.packages = res.data.data.map((item: any, index: number) => ({
        id: String(item.id || `${orderNo}-${index}`),
        label: `包裹${index + 1}`,
        company: item.logisticsCompany || '物流',
        number: item.logisticsNo || '',
        events: []
      })).filter((item: LogisticsPackage) => item.number);
      this.packages = await Promise.all(this.packages.map(async (item) => {
        const trackRes: any = await track({ logisticsNo: item.number, orderNo });
        if (trackRes.data.code === 100 && Array.isArray(trackRes.data.data)) {
          return {
            ...item,
            events: trackRes.data.data.map((event: any) => ({
              title: event.status || '',
              time: event.ftime || '',
              description: event.context || ''
            }))
          };
        }
        return item;
      }));
    }
  }

  get activePackage(): LogisticsPackage | null {
    return this.packages[this.activePackageIndex] || null;
  }

  copyNumber() {
    const number = this.activePackage ? this.activePackage.number : '';
    if (!number) return;

    const textarea = document.createElement('textarea');
    textarea.value = number;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.$message.success('物流单号已复制');
  }
}
